import { Model, IModel, ModelRecord } from './Model';
import { defaultTo } from 'lodash';
export interface ICommunicationTypeModel extends IModel {
  communicationTypeId: number;
  name: string | undefined;
}

export class CommunicationTypeModel
  extends Model
  implements ModelRecord<ICommunicationTypeModel>
{
  communicationTypeId: number;
  name: string | undefined;

  constructor(params?: Partial<ICommunicationTypeModel>) {
    super(params);
    this.communicationTypeId = defaultTo(params?.communicationTypeId, 0);
    this.name = defaultTo(params?.name, '');
  }
}
